<template>
	<div class="modal fade" id="showEditPartModal" tabindex="-1" aria-labelledby="showEditPartModalLabel" aria-hidden="true">
		<div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="showEditPartModalLabel">Modal Edit Part</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
				<div class="modal-body">
					<div style="display: flex; justify-content: center; align-items: flex-end">
						<div class="field">
							<label class="label">Original</label>
							<div class="control" style="margin-bottom: 1rem;">
								<div class="select">
									<select id="edit_part_select" v-model="indexPart">
										<option disabled value="">Edit Part</option>
										<option v-for="(part, key) in partsArray" :value="key" :key="key">
											{{ part }}
										</option>
									</select>
								</div>
							</div>
						</div>
						<div class="field" style="margin-left: 0.5rem; margin-right: 0.5rem">
							<label class="label">Corrected</label>
							<p class="control">
								<input class="input" id="edit_part_input" v-model="editPart" type="text" />
							</p>
						</div>
						<div class="field" style="margin-bottom: 1.75rem;">
							<button class="button is-info" @click="doEdit()">Edit</button>
						</div>
					</div>
					<div style="margin: 1.5rem 0; max-height: 200px; overflow-y: auto">
						<section>
							<div id="edit_part_list" style="
								display: flex;
								flex-direction: column;
								justify-content: space-evenly;
								">
								<div style="
									display: flex;
									flex-direction: row;
									justify-content: center;
									margin-bottom: 0.5rem;
								">
									<div>
										<ul v-if="Object.keys(updateParts).length">
											<li v-for="(newPart, oldPart) in updateParts" :key="oldPart">
												{{ partsArray[oldPart] }} → {{ newPart }}
											</li>
										</ul>
									</div>
								</div>
							</div>
						</section>
					</div>
				</div>
				<div class="modal-footer">
					<div class="buttons is-right" style="width: 100%">
						<button class="button is-danger" data-bs-dismiss="modal" aria-label="Close">Cancel</button>
						<button class="button is-success" @click="doSearch()">Search</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Modal } from 'bootstrap';

export default {
	name: "ModalEditPart",
	data() {
		return {
			updateParts: {},
			indexPart: "",
			editPart: "",
			oldPart: "",
		};
	},
	props: {
		partsArray: {
			type: Array,
			required: true,
		},
	},
	methods: {
		doEdit() {
			this.oldPart = this.partsArray[this.indexPart];
			this.updateParts[this.indexPart] = this.editPart;
		},
		doSearch() {
			const payload = {
				updatedParts: JSON.parse(JSON.stringify(this.updateParts)), 
				newPart: this.editPart, 
				oldPart: this.oldPart,
				indexPart: this.indexPart
			};
			this.$emit("doSearch", payload);

			const modalElement = document.getElementById('showEditPartModal');
            if (modalElement) {
                const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
                modal.hide();
            }
		},
	},
};
</script>

<style scoped>
</style>
